import React from "react";

import axios from "axios";

import { toast } from "react-toastify";

import * as Constants from "@app/Constant";

const AUTH_TOKEN = "authToken".toLowerCase();
axios.defaults.params = {};

const intance = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`,
});

intance.interceptors.request.use(
    (request) => {
        const authToken = localStorage.getItem("auth_token");
        if (authToken) {
            const userType = localStorage.getItem("login_user_type");
            const userIndex = localStorage.getItem("login_user_index");
            request.headers.userType = userType;
            request.headers.authToken = authToken;
            request.headers.userIndex = userIndex;
        }
        return request;
    },
    (error) => {
        return Promise.reject(error);
    }
);

intance.interceptors.response.use(
    (response) => {
        let errorMsg = "오류가 발생하였습니다.\n지속 발생시 관리자에게 문의해주세요.";
        // console.debug(response);
        if (response && response.data) {
            if (response.headers[AUTH_TOKEN]) {
                // console.debug('token refreshed', localStorage.getItem("auth_token"), '->', response.headers[AUTH_TOKEN]);
                localStorage.setItem("auth_token", response.headers[AUTH_TOKEN]);
            }
            if (response.data.code === Constants.RESPONSE.OK.code) {
                return response;
            }
            if (response.data.code === Constants.RESPONSE.INVALID_TOKEN.code) {
                const isLoginFromHq = localStorage.getItem("is_login_from_hq");
                const type = localStorage.getItem("login_user_type");
                localStorage.removeItem("is_login");
                localStorage.removeItem("is_login_from_hq");
                localStorage.removeItem("login_user_name");
                localStorage.removeItem("login_user_id");
                localStorage.removeItem("login_user_index");
                localStorage.removeItem("login_user_role");
                localStorage.removeItem("login_user_type");
                localStorage.removeItem("login_branch_id");
                localStorage.removeItem("login_branch_name");
                localStorage.removeItem("auth_token");
                alert(response.data.msg);
                if (isLoginFromHq == "yes") {
                    window.location.href = `/hq/login?type=${type}&redirect=${window.location.pathname}`;
                } else {
                    window.location.href = `/?redirect=${window.location.pathname}`;
                }
                return;
            }

            errorMsg = response.data.msg;
        }
        console.log(errorMsg);
        if (!response.config.extra || response.config.extra.showToast) {
            let multilineMsg = errorMsg.split('/n');
            toast.error(
                <div>
                    {multilineMsg.map((m, index) => {                        
                        if(index < multilineMsg.length - 1) {
                            return <>{m}<br /></>
                        } else return <>{m}</>
                    })}
                </div>
            );
        }
        return Promise.reject(response);
    },
    (error) => {
        console.log(error);
        toast.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
        return Promise.reject(error);
    }
);

export default intance;
